import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

import { SkeletonModule } from "primeng/skeleton";

import { AccordionComponent } from "@shared/components";
import { DaysData } from "@shared/models";

@Component({
  selector: "app-pvds",
  standalone: true,
  imports: [AccordionComponent, SkeletonModule, CommonModule],
  templateUrl: "./pvds.component.html",
  styleUrl: "./pvds.component.scss",
})
export class PvdsComponent {
  @Input() daysData: DaysData = {} as DaysData;

  visible: boolean = false;

  handleVisible(event: any) {
    this.visible = event;
  }
}
